<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
//import resize from './mixins/resize'
import chartResize from "./mixins/chart-resize";

export default {
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      console.log(data);
      this.chart.setOption({
        series: [
          {
            type: "gauge",
            radius: "70%",
            center: ["50%", "45%"],
            min: 0,
            max: this.chartData.maxValue,
            splitNumber: 1,
            progress: {
              show: true,
              width: 15,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "#5c53de",
                  },
                  {
                    offset: 1,
                    color: "#18c8ff",
                  },
                ]),
              },
            },
            pointer: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 15,
              },
            },
            axisLabel: {
              show: true,
              color: "#fff",
              distance: -35, //刻度位置
              formatter: function (val) {
                return val / 10000 + "万";
              },
            },
            detail: {
              show: true,
              valueAnimation: true,
              fontSize: 16,
              offsetCenter: [0, 0],
              color: "#5cacde",
              formatter: function (params) {
                return (params / 10000).toFixed(2) + "万";
              },
            },
            data: [
              {
                value: this.chartData.value,
              },
            ],
          },
        ],
      });
    },
  },
};
</script>
